import pino, { LoggerOptions } from "pino";

export type logOptions = {
  caller?: string;
  status?: number;
  data?: object;
};

const pinoConfig: LoggerOptions = {
  level: process.env.NODE_ENV === "production" ? "info" : "trace",
  formatters: {
    level: (label: string) => {
      return {
        level: label,
      };
    },
  },
  timestamp: pino.stdTimeFunctions.isoTime,
  browser: {
    asObject: true,
    write: {
      warn: function (o) {
        console.warn("warning", o);
      },
    },
  },
  transport:
    process.env.NODE_ENV == "development"
      ? {
          target: "pino-pretty",
          options: {
            colorize: true,
          },
        }
      : undefined,
};
const logger = pino(pinoConfig);

export const logTrace = (message: string, opt: logOptions = {}) => {
  logger.trace(opt, message);
};
export const logDebug = (message: string, opt: logOptions = {}) => {
  logger.debug(opt, message);
  //console.debug(message);
};
export const logInfo = (message: string, opt: logOptions = {}) => {
  logger.info(opt, message);
  //console.info(message);
};
export const logWarn = (message: string, opt: logOptions = {}) => {
  logger.warn(opt, message);
  //console.warn(message);
};
export const logError = (message: string, opt: logOptions = {}) => {
  logger.error(opt, message);
  //console.error(message);
};
export const logFatal = (message: string, opt: logOptions = {}) => {
  logger.fatal(opt, message);
  //console.error(message);
};
